export default __webpack_public_path__ + "static/media/hotgiggity-live-marker.d995589e.png";